import { useMemo } from 'react'
import { ValueNarrativeCategory } from '../../ValueNarrativesView/queries/useGetValueNarrativesQuery'
import { toDate } from '../../../shared/utils/toDate'
import { ValueMessageListItem, ValueMessageRow } from './ValueMessageTable.types'

const getSelectedNames = (selectionByName?: Record<string, boolean>) =>
    Object.entries(selectionByName ?? {})
        .filter(([, isSelected]) => isSelected)
        .map(([name]) => name)

const toValueMessageRow = (valueMessage: ValueMessageListItem): ValueMessageRow => ({
    ...valueMessage,
    audienceNames: getSelectedNames(valueMessage.audiences),
    internalStakeholderNames: getSelectedNames(valueMessage.internalStakeholders),
    linkedEvidenceCount: valueMessage.linkedEvidence?.length ?? 0,
    primaryEvidenceCount: valueMessage.primaryEvidence?.length ?? 0,
    keyEvidenceStatementCount: valueMessage.keyEvidenceStatements?.length ?? 0,
    evidenceGapCount: valueMessage.evidenceGapCount ?? 0,
    linkedActivityCount: valueMessage.linkedActivities?.length ?? 0,
    linkedStrategicImperativeCount: valueMessage.linkedStrategicImperatives?.length ?? 0,
    linkedTppCellCount: valueMessage.linkedTppCells?.length ?? 0,
    createdAtValue: toDate(valueMessage.createdAt),
    updatedAtValue: toDate(valueMessage.updatedAt),
})

const byOrder = (left: { order: number }, right: { order: number }) => left.order - right.order

const toValueMessageListItems = (categories: ValueNarrativeCategory[]): ValueMessageListItem[] =>
    [...categories].sort(byOrder).flatMap((category) =>
        category.narratives.flatMap((narrative) =>
            [...narrative.valueMessages].sort(byOrder).map((valueMessage) => ({
                ...valueMessage,
                categoryName: category.name,
                narrativeName: narrative.name,
                evidenceGapCount: valueMessage.evidenceGaps?.length ?? 0,
            }))
        )
    )

export const useValueMessageRows = (valueNarrativeCategories: ValueNarrativeCategory[] | undefined) =>
    useMemo(
        () => toValueMessageListItems(valueNarrativeCategories ?? []).map(toValueMessageRow),
        [valueNarrativeCategories]
    )
